/**
 * Kopfzeile auf Mobil: Die eigene Zeile des Netto/Brutto-Umschalters klappt beim
 * Runterscrollen weg und beim Hochscrollen wieder auf.
 *
 * Auf 390 px kostet die Zeile 55 der 167 px Kopfhoehe, und der Kopf ist sticky --
 * ein Drittel davon stuende sonst die ganze Sitzung im Bild. Beim Hochscrollen
 * kommt sie zurueck, damit die Preiswahl erreichbar bleibt, ohne bis zum
 * Seitenanfang zu scrollen.
 *
 * Das Theme macht auf Desktop dasselbe mit der Menuezeile, bindet seinen
 * Scroll-Zuhoerer aber nur oberhalb von 769 px (StickyHeader.init in
 * assets/main.js prueft theme.mediaMatches.md). Darunter passiert nichts,
 * deshalb diese Datei. Schwellen und Ablauf sind aus StickyHeader.handleScroll
 * uebernommen, damit sich beide Breiten gleich anfuehlen.
 *
 * Die Hoehe der Zeile wird gemessen und als --md-price-row-height an den Kopf
 * geschrieben. assets/custom.css braucht sie zweimal: als Startwert der
 * max-height-Animation -- von 'none' aus animiert nichts -- und als
 * Ausgleichsmarge am .header, die die Flusshoehe konstant haelt. Fest im CSS
 * waere sie falsch, sobald der Umschalter auf schmalen Geraeten umbricht oder
 * die Schriftgroesse abweicht.
 *
 * KEEP IN SYNC: Klassen- und Variablenname mit assets/custom.css.
 */
(function () {
  'use strict';

  var OUT_CLASS = 'md-price-row-out';
  var HEIGHT_VAR = '--md-price-row-height';

  // Dieselbe Grenze wie die Regeln in assets/custom.css, die die Zeile
  // ueberhaupt erst erzeugen. Oberhalb sitzt der Umschalter in der Icon-Zeile
  // und hat keine eigene Hoehe, die sich einklappen liesse.
  var MOBILE = '(max-width: 768.98px)';

  // Ganz oben immer offen, sonst blieben die Knoepfe nach einem Sprung an den
  // Seitenanfang unsichtbar. Die 5 px Spiel beim Hochscrollen fangen das
  // Zittern von Trackpads und Gummiband-Effekten ab.
  var ALWAYS_SHOWN_ABOVE = 200;
  var UP_SLACK = 5;

  var mq = window.matchMedia(MOBILE);
  var header = null;
  var row = null;
  var lastPos = document.documentElement.scrollTop;
  var scrollQueued = false;
  var measureQueued = false;

  /* Nicht dauerhaft zwischenspeichern: Der Theme-Editor rendert die Section bei
   * jeder Aenderung neu, danach zeigen alte Referenzen auf abgehaengte
   * Elemente. */
  function resolve() {
    header = document.querySelector('store-header');
    row = header ? header.querySelector('.header__price-row') : null;

    // Ohne sticky scrollt der Kopf ohnehin aus dem Bild -- dann gibt es nichts
    // zu gewinnen und der Scroll-Zuhoerer kann wegbleiben.
    return !!(row && header.dataset.isSticky);
  }

  /* 21.09.2026: Gemessen wird der INHALT der Zeile, nicht die Zeile. Die Zeile ist waehrend des Auf- und
   * Zuklappens nur zum Teil hoch; ihr Inhalt wird dabei bloss abgeschnitten und behaelt seine Hoehe.
   * Vorher mass diese Funktion die Zeile und sperrte sich nur, solange OUT_CLASS hing. Beim Hochscrollen
   * faellt die Klasse aber sofort weg, die Zeile klappt noch 0,3 s auf -- und iPhone-Safari blendet genau
   * dann seine Adressleiste ein und loest resize aus. Die halbe Hoehe wurde gespeichert und war ab da die
   * max-height: Der Umschalter blieb halb abgeschnitten (Nutzer 21.09.). Zeile und Inhalt sind gleich hoch,
   * die Zeile hat keinen Innenabstand (gemessen 45,0 und 45,0 px). */
  function measure() {
    if (!row) return;

    var inhalt = row.querySelector('.md-price-switch');
    if (!inhalt) return;

    var hoehe = inhalt.getBoundingClientRect().height;
    if (hoehe > 0) header.style.setProperty(HEIGHT_VAR, hoehe.toFixed(1) + 'px');
  }

  function apply() {
    if (!row || !header.dataset.isSticky) return;

    // body.fixed heisst: Menue oder Drawer ist offen und haelt die Seite fest.
    // Dieselbe Bedingung prueft StickyHeader.handleScroll, aus demselben Grund
    // -- der Scroll gehoert dann dem Overlay, nicht der Seite.
    if (document.body.classList.contains('fixed')) return;

    var pos = document.documentElement.scrollTop;

    if (pos < ALWAYS_SHOWN_ABOVE) {
      header.classList.remove(OUT_CLASS);
    } else if (pos > lastPos) {
      header.classList.add(OUT_CLASS);
    } else if (lastPos - UP_SLACK > pos) {
      header.classList.remove(OUT_CLASS);
    }

    lastPos = pos;
  }

  function onScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(function () {
      scrollQueued = false;
      apply();
    });
  }

  /* Auch der Breakpoint-Wechsel laeuft hier durch, statt ueber ein eigenes
   * matchMedia-Ereignis: Jede Breitenaenderung fuehrt zu resize, und sync()
   * entscheidet danach neu. Eine Regel weniger, die auseinanderlaufen kann. */
  function sync() {
    if (!resolve()) return;

    if (mq.matches) {
      measure();
      lastPos = document.documentElement.scrollTop;
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      header.classList.remove(OUT_CLASS);
      window.removeEventListener('scroll', onScroll);
    }
  }

  function syncSoon() {
    if (measureQueued) return;
    measureQueued = true;
    requestAnimationFrame(function () {
      measureQueued = false;
      sync();
    });
  }

  // Vor dem ersten sync(), damit eine zweite Ausfuehrung -- das Skript steht in
  // der Header-Section und wird im Theme-Editor mit ihr neu geladen -- keinen
  // zweiten Scroll-Zuhoerer anhaengt. Die Zuhoerer des ersten Durchlaufs leben
  // am document weiter und holen sich die neuen Elemente per resolve().
  if (window.mdPriceRowScrollBound) return;
  window.mdPriceRowScrollBound = true;

  sync();

  window.addEventListener('resize', syncSoon);
  document.addEventListener('shopify:section:load', sync);
})();
